export const ORIGIN = window.location.hostname === 'localhost' ? `http://${window.location.hostname}:4000` : window.location.origin;

export const restCall = (api, type, authToken, body) => {
  return fetch(ORIGIN + api, {
    method: type,
    headers: {'content-type': 'application/json', 'Authorization': authToken},
    body: JSON.stringify(body)
  });
}
